import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';

import { CreateRegion, CreateRegionVariables } from '../../athena/types/CreateRegion';
import { REGION_FIELDS } from '../../fragments/fence/region';

export const CREATE_REGION = gql`
  mutation CreateRegion(
    $identifier: String
    $description: String
    $tagIdentifiers: [String!]
    $postalCodes: [String!]
    $geojsonGeom: String
    $state: OdProtosCommonState_State
    $organizationUuid: [String!]
    $createdByToken: String
  ) {
    fence {
      createRegion(
        input: {
          identifier: $identifier
          description: $description
          tagsIdentifiers: $tagIdentifiers
          postalCodes: $postalCodes
          geojsonGeom: $geojsonGeom
          state: $state
          organizationUuid: $organizationUuid
          createdByToken: $createdByToken
        }
      ) {
        region {
          ...RegionFields
        }
      }
    }
  }
  ${REGION_FIELDS}
`;

export const useCreateRegion = () => {
  return useMutation<CreateRegion, CreateRegionVariables>(CREATE_REGION);
};
